import React from "react";
import { partners } from "../mock";

export default function PartnerMarquee() {
  const list = [...partners, ...partners];
  return (
    <section className="py-14 bg-white border-y border-border">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-8">
          <p className="text-xs uppercase tracking-[0.3em] text-brand-accent font-semibold" style={{ color: "var(--brand-500)" }}>Trusted by</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-brand mt-2">Our Partners</h2>
        </div>
        <div className="overflow-hidden no-scrollbar">
          <div className="marquee-track flex items-center gap-12">
            {list.map((p, i) => (
              <div
                key={i}
                className="flex-shrink-0 px-7 py-5 rounded-lg border border-border bg-muted/30 min-w-[210px] text-center"
              >
                <span className="font-display font-semibold text-brand/80 text-[15px] tracking-tight">{p}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
